import Model from '@/models/Model'

export class DnsZoneBase extends Model {
  get attributes () {
    return [
      'id',
      'name',
      'enabled',
      'ascii_name',
      'description',
      'records_amount',
      'url'
    ]
  }

  constructor (data) {
    super(data)

    this.name = data.name
  }
}
export class DnsZoneFull extends Model {
  get attributes () {
    return [
      'id',
      'name',
      'ascii_name',
      'enabled',
      'description'
    ]
  }

  constructor (data) {
    super(data)

    this.name = data.name
  }
}

export class DnsRRSetBase extends Model {
  get attributes () {
    return [
      'rr_name',
      'ascii_rr_name',
      'rr_type',
      'ttl',
      'weights_enabled',
      'url'
    ]
  }

  constructor (data) {
    super(data)

    this.rr_name = data.rr_name
  }
}
export class DnsRRSetFull extends Model {
  get attributes () {
    return [
      'rr_name',
      'ascii_rr_name',
      'rr_type',
      'ttl',
      'records',
      'weights_enabled'
    ]
  }

  constructor (data) {
    super(data)

    this.rr_name = data.rr_name
  }
}

export class DnsRecordBase extends Model {
  get attributes () {
    return [
      'rr_name',
      'ascii_rr_name',
      'rr_type',
      'ttl',
      'weights_enabled',
      'url'
    ]
  }

  constructor (data) {
    super(data)

    this.name = data.name
  }
}
export class DnsRecordFull extends Model {
  get attributes () {
    return [
      'id',
      'zone_name',
      'rr_name',
      'ascii_rr_name',
      'rr_type',
      'ttl',
      'content',
      'disabled',
      'weight',
      'modified_at'
    ]
  }

  constructor (data) {
    super(data)

    this.name = data.name
  }
}
